module.exports = __webpack_public_path__ + "img/clockImg.20f92768.svg";